import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import CoverFlow from "../components/coverflow";
import FormComp from '../components/Form'
import SwiperComp from '../components/swiper';

import Header from "../components/Header";
import Footer from "../components/Footer";
import Profile from "../components/Profile";
import Card from "../components/Card";
import "./Main.css";
import PS from "../assets/images/ps.png";
import AI from "../assets/images/ai.png";
import ID from "../assets/images/id.png";
import AE from "../assets/images/ae.png";

import Logo1 from "../assets/images/logo1.jfif";
import Logo2 from "../assets/images/logo2.jfif";
import Logo3 from "../assets/images/logo3.jfif";
import Logo4 from "../assets/images/logo4.jfif";

import Flyer1 from "../assets/images/flyer1.jfif";

import Banner1 from "../assets/images/banner1.jfif";
import Banner2 from "../assets/images/banner2.jfif";
import Banner3 from "../assets/images/banner3.jfif";

import Character1 from "../assets/images/cartoon1.jfif";
import Character2 from "../assets/images/cartoon2.jfif";
import Character3 from "../assets/images/cartoon3.jfif";
import Character4 from "../assets/images/cartoon4.jfif";
import Character5 from "../assets/images/cartoon5.jfif";
import Character6 from "../assets/images/cartoon6.jfif";
import Character7 from "../assets/images/cartoon7.jfif";

import Card1 from "../assets/images/card1.jfif";
import Card2 from "../assets/images/card2.jfif";

import Product1 from "../assets/images/product1.jfif";
import Product2 from "../assets/images/product2.jfif";
import Product3 from "../assets/images/product3.jfif";

const MainPage = (props) => {
  const [show, SetShow] = useState(false);
  const [visible, setVisible] = useState(3);
  const [LoadValue, setLoadValue] = useState("Load More");
  const Loadmore = () => {
    const Length = Data.map((data) => {
      return data.All.length;
    });
    if (Length <= visible) {
      setLoadValue("Load Less");
      setVisible(3);
    } else {
      setVisible((preValue) => preValue + 3);
      setLoadValue("Load More");
    }
  };
  useEffect(() => {
    setTimeout(() => {
      SetShow(true);
    }, 1500);
  });

  const SkillsData = [
    {
      name: "Abode Photoshop",
      url: PS,
      experience: "2 Years",
    },
    {
      name: "Abode Illustrator",
      url: AI,
      experience: "2 Years",
    },
    {
      name: "Abode InDesign",
      url: ID,
      experience: "1 Years",
    },
    {
      name: "Abode After Effects",
      url: AE,
      experience: "1 Years",
    },
  ];
  const Data = [
    {
      Mix: [
        {
          name: "Banner 2",
          type: "Vintage",
          url: "https://cdn.dribbble.com/users/2417352/screenshots/14784675/media/11e070dbbc6470cab72310f25c2f8aae.png?compress=1&resize=400x300&vertical=top",
        },
        {
          name: "Logo 1",
          type: "T-Shirt",
          url: "https://images-platform.99static.com/8RQTIEMwYAjw4hx68dSw01Fihj8=/0x0:960x960/500x500/top/smart/99designs-contests-attachments/113/113241/attachment_113241116",
        },
        {
          name: "Logo 2",
          type: "T-Shirt",
          url: "https://www.kindpng.com/picc/m/418-4187509_sos-factory-clipart-png-download-mascot-character-transparent.png",
        },
        {
          name: "Logo 3",
          type: "Company",
          url: "https://www.kindpng.com/picc/m/61-613047_mascot-vector-illustrator-sosfactory-monkey-hd-png-download.png",
        },
        {
          name: "Card 1",
          type: "ID",
          url: "https://i0.wp.com/www.flylanddesigns.com/wp-content/uploads/03-Mario-Character-Design.jpg?ssl=1",
        },
        {
          name: "Card 2",
          type: "ID",
          url: "https://i0.wp.com/www.flylanddesigns.com/wp-content/uploads/Sticker-Frankenstien.jpg?fit=560%2C700&ssl=1",
        },
      ],
      All: [
        {
          name: "Logo 1",
          type: "T-Shirt",
          url: Logo1,
        },
        {
          name: "Logo 2",
          type: "T-Shirt",
          url: Logo2,
        },
        {
          name: "Logo 3",
          type: "Company",
          url: Logo3,
        },
        {
          name: "Logo 4",
          type: "Cartoon",
          url: Logo4,
        },

        {
          name: "Flyer 1",
          type: "Product",
          url: Flyer1,
        },
        {
          name: "Banner 1",
          type: "3D",
          url: Banner1,
        },
        {
          name: "Banner 2",
          type: "Vintage",
          url: Banner2,
        },
        {
          name: "Banner 2",
          type: "Vintage",
          url: Banner3,
        },
        {
          name: "Product 1",
          type: "Oil",
          url: Product1,
        },
        {
          name: "Product 2",
          type: "Cream",
          url: Product2,
        },
        {
          name: "Product 3",
          type: "Mix",
          url: Product3,
        },
        {
          name: "Card 1",
          type: "ID",
          url: Card1,
        },
        {
          name: "Card 2",
          type: "ID",
          url: Card2,
        },
        {
          name: "Character 1",
          type: "Corn Man",
          url: Character1,
        },
        {
          name: "Character 2",
          type: "Gentle Monkey",
          url: Character2,
        },
        {
          name: "Character 3",
          type: "Gun Man",
          url: Character3,
        },
        {
          name: "Character 4",
          type: "Gangster",
          url: Character4,
        },
        {
          name: "Character 5",
          type: "Monkey",
          url: Character5,
        },
        {
          name: "Character 6",
          type: "Santa",
          url: Character6,
        },
        {
          name: "Character 7",
          type: "Monkey",
          url: Character7,
        },
      ],
    },
  ];

  return show ? (
    <>
      <Header />
      <Profile data={Data} />
      <Container>
        <Row className="profile-container" id="home">
          <Col xs={11} sm={12} lg={12}>
            <CoverFlow data={Data} />
          </Col>
        </Row>
      </Container>

      <Container id="skills">
        <h1 className="header-title-card contact-text">Skills</h1>

        <Row className="justify-content-center skills-row">
          {SkillsData.map((skills, id) => {
            return (
              <Col id={id} md={6} xl={3}>
                <h5 className="skills-title">{skills.name}</h5>
                <img
                  className="skills-img"
                  src={skills.url}
                  alt={skills.name}
                />
                <p className="skills-para">Experience : {skills.experience}</p>
              </Col>
            );
          })}
        </Row>
      </Container>
      <Container id="qualification">
        <h1 className="header-title-card contact-text">Qualifications</h1>

        <Row className="justify-content-around qualification-row">
          <Col md={6} xl={4}>
            <h4 className="qualification-head">BE Mining Engineering</h4>
            <p className="qualification-para">Mehran UET Jamshoro, Pakistan</p>
            <p className="qualification-para">2017 - 2021</p>
            <br />
            <br />
            <br />
            <h4 className="qualification-head">Graphics Design</h4>
            <p className="qualification-para">
              Saylani Mass IT Training Programme Pakistan
            </p>
            <p className="qualification-para">2020</p>
          </Col>
          <Col md={6} xl={4}>
            <h4 className="qualification-head">Adobe Illustrator</h4>
            <p className="qualification-para">
              Saylani Mass IT Training Programme Pakistan
            </p>
            <p className="qualification-para">2020</p>
            <br />
            <br />
            <br />
            <h4 className="qualification-head">Adobe Photoshop</h4>
            <p className="qualification-para">
              Saylani Mass IT Training Programme Pakistan
            </p>
            <p className="qualification-para">2020</p>
          </Col>
        </Row>
      </Container>

      <Container id="my-work">
        <h1 className="header-title-card contact-text">Projects</h1>

        <Row className="justify-content-between">
          {Data.map((all, id) => {
            return all.All.slice(0, visible).map((all, index) => {
              return (
                <Col key={index} md={6} xl={4}>
                  <Card name={all.name} type={all.type} url={all.url} />
                </Col>
              );
            });
          })}
        </Row>
        <div className="loadmore-btn-div">
          <button className="loadmore-btn" onClick={Loadmore}>
            {LoadValue}
          </button>
        </div>
      </Container>
<Container>
<h1 className='header-title-card contact-text'>Contact</h1>
            <Row className='justify-content-around form-container'>
            <Col md={7}>
            <FormComp />

            </Col>
            <Col md={4}>
            <SwiperComp Data={Data} />

            </Col>
            </Row>
</Container>
      <Footer Data={Data} />
    </>
  ) : (
    <div class="container-loader">
      <div class="loader">
        <span></span>
      </div>
    </div>
  );
};

export default MainPage;
